var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInvoiceCardImage = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-14,.cls-6{fill:none}.cls-1,.cls-2{clip-rule:evenodd}.cls-2,.cls-8{fill:#5f7278}.cls-3{clip-path:url(#clip-path)}.cls-4{fill:#fff}.cls-5{clip-path:url(#clip-path-2)}.cls-14,.cls-6{stroke:#5f7278}.cls-6{stroke-width:2px}.cls-7{clip-path:url(#clip-path-3)}.cls-9{clip-path:url(#clip-path-4)}.cls-10{clip-path:url(#clip-path-5)}.cls-11{clip-path:url(#clip-path-6)}.cls-12{clip-path:url(#clip-path-7)}.cls-13{clip-path:url(#clip-path-8)}.cls-14{stroke-width:.3px}\n        "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_50",
  d: "M0-24h48v48H0z",
  className: "cls-1",
  "data-name": "Path 50",
  transform: "translate(0 24)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  d: "M6-22h28.006a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-36a2 2 0 0 1 2-2z",
  className: "cls-1",
  "data-name": "Path 52",
  transform: "translate(-4 22)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_54",
  d: "M7-18v2h10v-2z",
  className: "cls-2",
  "data-name": "Path 54",
  transform: "translate(-7 18)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-4"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_56",
  d: "M7-12v2h20v-2z",
  className: "cls-2",
  "data-name": "Path 56",
  transform: "translate(-7 12)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-5"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_58",
  d: "M7-15v2h8v-2z",
  className: "cls-2",
  "data-name": "Path 58",
  transform: "translate(-7 15)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-6"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_60",
  d: "M7-9v2h16v-2z",
  className: "cls-2",
  "data-name": "Path 60",
  transform: "translate(-7 9)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-7"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_62",
  d: "M7-6v2h12v-2z",
  className: "cls-2",
  "data-name": "Path 62",
  transform: "translate(-7 6)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-8"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_64",
  d: "M18.309-11.567a1.008 1.008 0 0 0-.416-.816 4.043 4.043 0 0 0-1.4-.6 4.843 4.843 0 0 1-2-.892 1.776 1.776 0 0 1-.628-1.4 1.818 1.818 0 0 1 .616-1.416 2.88 2.88 0 0 1 1.692-.658V-18.5h.96v1.158a2.676 2.676 0 0 1 1.686.742 2.338 2.338 0 0 1 .6 1.7h-1.188a1.6 1.6 0 0 0-.432-1.179 1.566 1.566 0 0 0-1.167-.437 1.846 1.846 0 0 0-1.173.324 1.09 1.09 0 0 0-.406.9 1.012 1.012 0 0 0 .429.855 4.33 4.33 0 0 0 1.412.579 6.619 6.619 0 0 1 1.534.574 2.229 2.229 0 0 1 .812.729 1.793 1.793 0 0 1 .261.974 1.768 1.768 0 0 1-.654 1.432 3.244 3.244 0 0 1-1.834.642V-8.5h-.954v-1a3.079 3.079 0 0 1-1.879-.7 2.1 2.1 0 0 1-.68-1.65h1.192a1.388 1.388 0 0 0 .471 1.127 2.02 2.02 0 0 0 1.334.395 2.319 2.319 0 0 0 1.328-.332 1.042 1.042 0 0 0 .484-.907z",
  className: "cls-1",
  "data-name": "Path 64",
  transform: "translate(-13.5 18.5)"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_555",
  "data-name": "Group 555",
  transform: "translate(0 24)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_92",
  className: "cls-3",
  "data-name": "Group 92",
  transform: "translate(0 -24)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_49",
  d: "M-5-29h68v68H-5z",
  className: "cls-4",
  "data-name": "Path 49",
  transform: "translate(-5 19)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_94",
  className: "cls-5",
  "data-name": "Group 94",
  transform: "translate(7.997 -19.999)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_93",
  "data-name": "Group 93"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_51",
  d: "M2 0h28.006a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z",
  className: "cls-6",
  "data-name": "Path 51"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_95",
  className: "cls-7",
  "data-name": "Group 95",
  transform: "translate(13.999 -12)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  d: "M2-23h30.006v22H2z",
  className: "cls-8",
  "data-name": "Path 53",
  transform: "translate(-12.002 12.998)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_96",
  className: "cls-9",
  "data-name": "Group 96",
  transform: "translate(13.998)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_55",
  d: "M2-17h40.007V5H2z",
  className: "cls-8",
  "data-name": "Path 55",
  transform: "translate(-12.002 6.998)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_97",
  className: "cls-10",
  "data-name": "Group 97",
  transform: "translate(13.999 -6)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_57",
  d: "M2-20h28.005V2H2z",
  className: "cls-8",
  "data-name": "Path 57",
  transform: "translate(-12.002 9.998)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_98",
  className: "cls-11",
  "data-name": "Group 98",
  transform: "translate(13.999 6)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_59",
  d: "M2-14h36.007V8H2z",
  className: "cls-8",
  "data-name": "Path 59",
  transform: "translate(-12.002 3.998)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_99",
  className: "cls-12",
  "data-name": "Group 99",
  transform: "translate(13.999 12)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_61",
  d: "M2-11h32.006v22H2z",
  className: "cls-8",
  "data-name": "Path 61",
  transform: "translate(-12.002 .998)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_100",
  className: "cls-13",
  "data-name": "Group 100",
  transform: "translate(26.999 -13.001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63",
  d: "M8.5-23.5h26V6.506h-26z",
  className: "cls-8",
  "data-name": "Path 63",
  transform: "translate(-18.502 13.498)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_101",
  "data-name": "Group 101",
  transform: "translate(26.999 -13.001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_65",
  d: "M4.809 6.933a1.008 1.008 0 0 0-.416-.816 4.042 4.042 0 0 0-1.4-.6 4.844 4.844 0 0 1-2-.892 1.776 1.776 0 0 1-.628-1.4 1.818 1.818 0 0 1 .612-1.414 2.88 2.88 0 0 1 1.692-.658V0h.96v1.158a2.676 2.676 0 0 1 1.686.742 2.338 2.338 0 0 1 .6 1.7H4.731A1.6 1.6 0 0 0 4.3 2.422a1.566 1.566 0 0 0-1.167-.437 1.846 1.846 0 0 0-1.173.324 1.09 1.09 0 0 0-.406.9 1.012 1.012 0 0 0 .429.855 4.331 4.331 0 0 0 1.412.579 6.62 6.62 0 0 1 1.534.574 2.229 2.229 0 0 1 .812.729A1.793 1.793 0 0 1 6 6.922a1.768 1.768 0 0 1-.654 1.432A3.243 3.243 0 0 1 3.513 9v1h-.954V9A3.079 3.079 0 0 1 .68 8.3 2.1 2.1 0 0 1 0 6.649h1.192a1.388 1.388 0 0 0 .471 1.127A2.02 2.02 0 0 0 3 8.17a2.319 2.319 0 0 0 1.328-.332 1.042 1.042 0 0 0 .481-.905z",
  className: "cls-14",
  "data-name": "Path 65"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInvoiceCardImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/invoice_card_image.a779e3e900cde0fe85370435474ccdf6.svg";